import React from 'react';
import company from './company.json';
import './CompanyIntro.css';

function CompanyIntro({ lang = 'en' }) {
    const code = Object.hasOwn(company, lang) ? lang : 'en';
    const text = company[code];
    return (
        <section className="company-intro" aria-labelledby="pinta-title">
            <div className="company-product-heading">
                <img src="/resources/pinta-logo.webp" alt="PINTA" width="80" height="80" />
                <div>
                    <p className="company-eyebrow">{text.eyebrow}</p>
                    <h2 id="pinta-title">{text.heading}</h2>
                </div>
            </div>
            <div className="company-product-lead">
                <p>{text.description}</p>
                <p>{text.product}</p>
            </div>
            <div className="company-product-features">
                {text.highlights.map(([title, description], index) => (
                    <article key={title}>
                        {index === 3 && <span className="company-upcoming">{text.upcoming}</span>}
                        <h3>{title}</h3>
                        <p>{description}</p>
                    </article>
                ))}
            </div>
            <p className="company-catalog">{text.catalog}</p>
            <div className="company-product-footer">
                <div>
                    <p className="company-devices">{text.devices}</p>
                    <p className="company-pricing">{text.pricing}</p>
                </div>
                <a className="company-button" href={`https://pintacoloring.com/${code}/`}>{text.link} →</a>
            </div>
        </section>
    );
}

export default CompanyIntro;
